import { createSelector } from '@reduxjs/toolkit';

import { getSeasonById } from '~/helpers/ladder';

import type { RootState } from '~/store';

export const membersCurrentSeasonSelector = (state: RootState) => state.members.currentSeason;

export const membersCurrentSeasonTypeSelector = createSelector(membersCurrentSeasonSelector, (currentSeason) => {
  return getSeasonById(currentSeason)?.kind || {};
});
